import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APP_ROUTES } from 'src/app/core/config/routes';
import { APP_MOCKS } from 'src/app/core/endpoints/app.endpoints';
import { AuthService } from 'src/app/features/auth/services/auth.service';
import { SharedService } from '../services/shared.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class HttpMockInterceptor implements HttpInterceptor {
  isLoading = false;
  counter: number = 0;

  constructor(
    private sharedService: SharedService,
    private toastrService: ToastrService,
    private spinnerService: NgxSpinnerService,
    private authService: AuthService,
    private router: Router,
    private message: NzMessageService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (this.sharedService.isMock) {
      if (
        req.method !== 'GET' &&
        !req.url.includes('signin') &&
        !req.url.includes('otp')
      ) {
        // Your mock logic here
      }
      const mock = APP_MOCKS[req.url];
      if (mock) {
        return of(
          new HttpResponse({
            status: 200,
            body: { data: mock }
          })
        );
      }
    } else {
      this.counter++;
     
      if (req.method !== 'GET') this.spinnerService.show();

      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.counter--;
            if (!this.counter) {
              this.spinnerService.hide();
            }
            if (this.counter < 0) this.counter = 0;
          }
          return event;
        }),
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            this.counter--;
            if (!this.counter) {
              this.spinnerService.hide();
              
              const arabic = /[\u0600-\u06FF]/;
              const errorMessage = error?.error?.message || '';
              const isArabic = arabic.test(errorMessage);

              switch (error.status) {
                case 406:
                case 400:
                case 404:
                case 409:
                  if (isArabic) {
                    this.message.error(errorMessage);
                  } else {
                    this.message.error('الرجاء التثبت');
                  }
                  break;
                
                case 401:
                case 403:
                  if (isArabic) {
                    this.message.error(errorMessage);
                  } else {
                    localStorage.clear();
                    this.sharedService.connectedUserInfo = null;
                    this.router.navigate([APP_ROUTES.AUTH.LOGIN]).then(
                      () => window.location.reload()
                    );
                  }
                  break;
                
                default:
                  this.message.error('عذرا لقد حصل خطأ');
              }
            }

            return throwError(error);
          }
          return throwError(error);
        })
      );
    }
  }
}